import { Box, CircularProgress, Typography } from '@mui/material';
import ReviewOtpIcon from '../../../../../icons/ReviewOtpIcon.svg';
import DownloadBlack from '../../../../../icons/DownloadBlack.svg';

export interface ApplicationSummaryDetailsDownloadsRowProps {
  /**
   *Flag that tells us we are fetching the document URL for viewing in a new tab
   */
  isFetchingDocumentURL: boolean;

  /**
   *Flag that tells us we are downloading the document
   */
  isDownloadingDocumentURL: boolean;

  /**
   * Title of the document (Release, Application etc)
   */
  title: string;

  /**
   * Callback fired when the download document icon is clicked
   * @returns
   */
  handleClickDownload: () => void;

  /**
   * Callback fired when the view document icon is clicked
   * @returns
   */
  handleClickView: () => void;
}
export default function ApplicationDetailsSummaryDownloadsRow(props: ApplicationSummaryDetailsDownloadsRowProps) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: 1, paddingLeft: 2 }}>
      <Typography sx={{ fontFamily: 'Work Sans !important', fontSize: 'large' }}>{props.title}</Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', width: '60px', justifyContent: 'space-between' }}>
        {props.isFetchingDocumentURL ? (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress size={18} />
          </Box>
        ) : (
          <img src={ReviewOtpIcon} alt="Downloads" style={{ cursor: 'pointer' }} width={13} height={14} onClick={props.handleClickView} />
        )}
        {props.isDownloadingDocumentURL ? (
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress size={18} />
          </Box>
        ) : (
          <img src={DownloadBlack} alt="Downloads" width={13} height={14} style={{ cursor: 'pointer' }} onClick={props.handleClickDownload} />
        )}
      </Box>
    </Box>
  );
}
